export async function setFraccionamiento(id_fraccionamiento) {
    this.setState({fracActual: id_fraccionamiento})
};

export async function setNombreFraccionamiento(nombre) {
    this.setState({fraccionamiento: nombre});
};